"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatWithMe = void 0;
var lit_html_1 = require("lit-html");
var solid_ui_1 = require("solid-ui");
var async_replace_js_1 = require("lit-html/directives/async-replace.js");
var texts_1 = require("./texts");
var ChatWithMe = function (subject, context) {
    var logic = context.session.logic;
    var longChatPane = context.session.paneRegistry.byName("long chat");
    function chatContainer() {
        return __asyncGenerator(this, arguments, function chatContainer_1() {
            var chatContainer, exists, e_1, button;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chatContainer = context.dom.createElement("div");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, __await(texts_1.loadingMessage)];
                    case 2: return [4 /*yield*/, _a.sent()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, __await(logic.chat.getChat(subject, false))];
                    case 4:
                        (exists = _a.sent());
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        exists = false;
                        return [3 /*break*/, 6];
                    case 6:
                        if (!exists) return [3 /*break*/, 9];
                        chatContainer.appendChild(longChatPane.render(exists, context, {}));
                        return [4 /*yield*/, __await(chatContainer)];
                    case 7: return [4 /*yield*/, _a.sent()];
                    case 8:
                        _a.sent();
                        return [3 /*break*/, 12];
                    case 9:
                        button = solid_ui_1.widgets.button(context.dom, undefined, texts_1.chatWithMeButtonText, function () { return __awaiter(_this, void 0, void 0, function () {
                            var chat, e_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, logic.chat.getChat(subject, true)];
                                    case 1:
                                        chat = _a.sent();
                                        chatContainer.innerHTML = "";
                                        chatContainer.appendChild(longChatPane.render(chat, context, {}));
                                        return [3 /*break*/, 3];
                                    case 2:
                                        e_2 = _a.sent();
                                        chatContainer.appendChild(solid_ui_1.widgets.errorMessageBlock(context.dom, e_2.message));
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }, { needsBorder: true });
                        chatContainer.appendChild(button);
                        return [4 /*yield*/, __await(chatContainer)];
                    case 10: return [4 /*yield*/, _a.sent()];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    }
    return (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject([" ", " "], [" ", " "])), (0, async_replace_js_1.asyncReplace)(chatContainer()));
};
exports.ChatWithMe = ChatWithMe;
var templateObject_1;
//# sourceMappingURL=ChatWithMe.js.map